var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "115px",
    viewBox: "0 0 115 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon - Circle Check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-(password-success)",
    transform: "translate(-154.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(90.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon---Circle-Check",
    transform: "translate(67.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#28EBC1",
    strokeWidth: 5,
    cx: 54.5,
    cy: 54.5,
    r: 54.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.761225,33.4824052 L46.4349174,71.9176551 L33.238775,58.3294632 C32.6141261,57.6862563 31.6013043,57.6862563 30.9765221,58.3294632 L29.4684867,59.8823013 C28.8438378,60.5255082 28.8438378,61.5684203 29.4684867,62.2117645 L45.3038576,78.5175948 C45.9285066,79.1608017 46.9413283,79.1608017 47.5661106,78.5175948 L87.5315133,37.3648438 C88.1561622,36.7216369 88.1561622,35.6787248 87.5315133,35.0353806 L86.0233446,33.4824052 C85.3986957,32.8391983 84.3858739,32.8391983 83.761225,33.4824052 Z",
    id: "Path",
    fill: "#28EBC1",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.991ee8545331497a2a7f366947f1172a.svg";
export { ForwardRef as ReactComponent };